import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CIRCLES_FETCH,
  CIRCLES_OPTIONS_FETCH,
  CIRCLES_CONTACTS_FETCH,
} from './constants';
import { PAGINATION } from '@/constants/pagination';

const getCircles = async (
  { filters = {}, sortOption = {}, page = {}, currUser, ignoreId = 0 },
  { extra: { http } },
  _getState
) => {
  try {
    const {
      company,
      employeeRange,
      businessType,
      industry,
      location,
      tags,
      skills,
      jobTitle,
      circleChanged,
      user,
      pastCompany,
    } = filters;
    const { element, order } = sortOption;
    const { limit, offset } = page;
    // Note - This should be dynamic/configurable filter.
    const params = {
      limit: PAGINATION.CONTACTS,
      offset: 0,
      sort_element: 'c_c',
      sort_order: 'desc',
      ignore_user_ids:
        ignoreId === null ? [currUser?.id] : ignoreId === 0 ? [] : [ignoreId],
    };

    if (limit && offset) {
      params.limit = limit || PAGINATION.CONTACTS;
      params.offset = offset || 0;
    }

    if (element && order) {
      params.sort_element = element;
      params.sort_order = order;
    }

    if (company?.length) {
      const companyIds = company.map(({ id }) => id);
      params.company_id = companyIds;
    }
    if (pastCompany?.length) {
      const pastCompanyIds = pastCompany?.map(({ id }) => id);
      params.past_company_id = pastCompanyIds;
    }

    if (employeeRange?.length) {
      params.company_employee_range = employeeRange;
    }
    if (businessType?.key) {
      params.company_type = [businessType?.key];
    }
    if (industry?.length) {
      const industryIds = industry.map((i) => i.key);
      params.company_industry = industryIds;
    }
    if (tags?.length) {
      const tagIds = tags.map((tag) => tag?.id);
      params.tags = tagIds;
    }

    if (jobTitle?.length) {
      const jobTitleLabel = jobTitle.map((job) => job?.label);
      params.position = jobTitleLabel;
    }

    if (skills?.length) {
      const skillIds = skills.map((skill) => skill?.id);
      params.skills = skillIds;
    }

    if (location?.length) {
      const locationIds = location.map(({ value }) => value);
      params.location = locationIds;
    }

    if (circleChanged) {
      if (user?.[0]?.id === 'org' || !user?.[0]?.id) {
        params.user_ids = [];
      } else {
        params.user_ids = user.map((u) => u?.id);
      }
    } else {
      params.user_ids = [];
    }

    const circles = await http.post(`/search/circles`, params);
    return circles;
  } catch {}
};

const getCirclesContacts = async (
  { filters = {}, sortOption = {}, page = {}, currUser, ignoreId = 0 },
  { extra: { http } },
  _getState
) => {
  try {
    const {
      company,
      employeeRange,
      businessType,
      industry,
      location,
      tags,
      skills,
      jobTitle,
      circleChanged,
      user,
      pastCompany,
    } = filters;
    const { element, order } = sortOption;
    const { limit, offset } = page;
    // Note - This should be dynamic/configurable filter.
    const params = {
      limit: 50,
      offset: 0,
      sort_element: 'name',
      sort_order: 'asc',
      ignore_user_ids:
        ignoreId === null ? [currUser?.id] : ignoreId === 0 ? [] : [ignoreId],
      extended_fields: true,
    };

    if (limit && offset) {
      params.limit = limit;
      params.offset = offset;
    }

    if (element && order) {
      params.sort_element = element;
      params.sort_order = order;
    }

    if (company?.length) {
      params.company_id = company?.map(({ id }) => id);
    }
    if (pastCompany?.length) {
      params.past_company_id = pastCompany?.map(({ id }) => id);
    }

    if (employeeRange?.length) {
      params.company_employee_range = employeeRange;
    }
    if (businessType?.key) {
      params.company_type = [businessType?.key];
    }
    if (industry?.length) {
      params.company_industry = industry?.map((i) => i.key);
    }
    if (tags?.length) {
      params.tags = tags?.map((tag) => tag?.id);
    }

    if (jobTitle?.length) {
      params.position = jobTitle?.map((job) => job?.label);
    }

    if (skills?.length) {
      params.skills = skills?.map((skill) => skill?.id);
    }

    if (location?.length) {
      params.location = location?.map(({ value }) => value);
    }

    if (circleChanged) {
      if (user?.[0]?.id === 'org' || !user?.[0]?.id) {
        params.user_ids = [];
      } else {
        params.user_ids = user?.map((u) => u?.id);
      }
    } else {
      params.user_ids = [];
    }

    const circlesContacts = await http.post(`/search/circles/contacts`, params);
    return circlesContacts;
  } catch {}
};

const getCirclesOptions = async (_, { extra: { http } }) => {
  try {
    const circleOptions = await http.get(`/search/circles/options`);
    return circleOptions;
  } catch {}
};

export const fetchCircles = createAsyncThunk(CIRCLES_FETCH, getCircles);
export const fetchCirclesContacts = createAsyncThunk(
  CIRCLES_CONTACTS_FETCH,
  getCirclesContacts
);
export const fetchCirclesOptions = createAsyncThunk(
  CIRCLES_OPTIONS_FETCH,
  getCirclesOptions
);
